import { SiteLinks } from "../../../../global/paywall/paywallInterfaces";

declare const window: Window & {
    PAYWALL_SITE_LINKS: SiteLinks;
}

 
export class YplusAccessibiltyButton extends React.Component<{}, {}> {
    public static siteScriptName = "yplusAccessibiltyFixedBtn";

    private clickAcessibilityBtn = () => {
        window[`EquallyAI`]  &&  window[`EquallyAI`].openToolbox();
        window[`interdeal`] && window[`interdeal`][`a11y`] && window[`interdeal`][`a11y`].openMenu();
    }

    render() {
    const contactUrl = typeof window !== "undefined" && window.PAYWALL_SITE_LINKS ? window.PAYWALL_SITE_LINKS.contact : '';
    const termsUrl = typeof window !== "undefined" && window.PAYWALL_SITE_LINKS ? window.PAYWALL_SITE_LINKS.terms : '';
    const privacyUrl = typeof window !== "undefined" && window.PAYWALL_SITE_LINKS ? window.PAYWALL_SITE_LINKS.privacy : '';
    
        return (
                     <> <div className="footerCopyright">
                                <a href={contactUrl} target="_blank" id="contactUs">צור קשר</a>
                                |
                                <a href={privacyUrl} target="_blank">מדיניות פרטיות</a>
                                |
                                <a href={termsUrl} target="_blank">תנאי שימוש</a>
                            </div>
            
                            <div className="moreInfo">לביטול מינוי <span style={{ display: "inline-block", direction: "ltr" }}>+ידיעות</span> כדין יש לשלוח שם מלא ות.ז. באחד האופנים הבאים: מילוי הטופס או בדוא"ל <a href="mailto:support.plus@ynet.co.il">support.plus@ynet.co.il</a>  או בת.ד. 438 ראשון לציון או בטל' 3773*/03-6933933 או בפקס: 03-6933999</div>
            
            <button className="accessibiltyFixedBtn" onClick={this.clickAcessibilityBtn} id="INDmenu-btn-fixed" title="אתר נגיש" aria-labelledby="INDbtnTooltip" accessKey="m"></button></>
        )
    }
}